/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponseDto } from '../models';
// @ts-ignore
import type { OrderExportResponseDto } from '../models';
// @ts-ignore
import type { OrderHistoryPosResponseDto } from '../models';
// @ts-ignore
import type { OrderHistoryResponseDto } from '../models';
// @ts-ignore
import type { OrderStatusEnum } from '../models';
// @ts-ignore
import type { OrderType } from '../models';
// @ts-ignore
import type { PaymentMethod } from '../models';
// @ts-ignore
import type { PaymentStatus } from '../models';
// @ts-ignore
import type { PaymentTypeEnum } from '../models';
// @ts-ignore
import type { ProviderEnum } from '../models';
// @ts-ignore
import type { TimeSpan } from '../models';
/**
 * HistoryApi - axios parameter creator
 * @export
 */
export const HistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export online order history as CSV
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrderHistoryOnline: async (businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessIds' is not null or undefined
            assertParamExists('exportOrderHistoryOnline', 'businessIds', businessIds)
            const localVarPath = `/api/v1/history/orders/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeSpan !== undefined) {
                localVarQueryParameter['timeSpan'] = timeSpan;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (businessIds) {
                localVarQueryParameter['businessIds'] = businessIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowPerPage !== undefined) {
                localVarQueryParameter['rowPerPage'] = rowPerPage;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentType) {
                localVarQueryParameter['paymentType'] = paymentType;
            }

            if (orderStatus) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (paymentStatus) {
                localVarQueryParameter['paymentStatus'] = paymentStatus;
            }

            if (orderType) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (paymentTypePos) {
                localVarQueryParameter['paymentTypePos'] = paymentTypePos;
            }

            if (invoiceCompanyId !== undefined) {
                localVarQueryParameter['invoiceCompanyId'] = invoiceCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export POS order history as CSV
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrderHistoryPOS: async (businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessIds' is not null or undefined
            assertParamExists('exportOrderHistoryPOS', 'businessIds', businessIds)
            const localVarPath = `/api/v1/history/orders/pos/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeSpan !== undefined) {
                localVarQueryParameter['timeSpan'] = timeSpan;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (businessIds) {
                localVarQueryParameter['businessIds'] = businessIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowPerPage !== undefined) {
                localVarQueryParameter['rowPerPage'] = rowPerPage;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentType) {
                localVarQueryParameter['paymentType'] = paymentType;
            }

            if (orderStatus) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (paymentStatus) {
                localVarQueryParameter['paymentStatus'] = paymentStatus;
            }

            if (orderType) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (paymentTypePos) {
                localVarQueryParameter['paymentTypePos'] = paymentTypePos;
            }

            if (invoiceCompanyId !== undefined) {
                localVarQueryParameter['invoiceCompanyId'] = invoiceCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get order history
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHistoryOnline: async (businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessIds' is not null or undefined
            assertParamExists('getOrderHistoryOnline', 'businessIds', businessIds)
            const localVarPath = `/api/v1/history/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeSpan !== undefined) {
                localVarQueryParameter['timeSpan'] = timeSpan;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (businessIds) {
                localVarQueryParameter['businessIds'] = businessIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowPerPage !== undefined) {
                localVarQueryParameter['rowPerPage'] = rowPerPage;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentType) {
                localVarQueryParameter['paymentType'] = paymentType;
            }

            if (orderStatus) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (paymentStatus) {
                localVarQueryParameter['paymentStatus'] = paymentStatus;
            }

            if (orderType) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (paymentTypePos) {
                localVarQueryParameter['paymentTypePos'] = paymentTypePos;
            }

            if (invoiceCompanyId !== undefined) {
                localVarQueryParameter['invoiceCompanyId'] = invoiceCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get order history for POS
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHistoryPOS: async (businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessIds' is not null or undefined
            assertParamExists('getOrderHistoryPOS', 'businessIds', businessIds)
            const localVarPath = `/api/v1/history/orders/pos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeSpan !== undefined) {
                localVarQueryParameter['timeSpan'] = timeSpan;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (businessIds) {
                localVarQueryParameter['businessIds'] = businessIds;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowPerPage !== undefined) {
                localVarQueryParameter['rowPerPage'] = rowPerPage;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentType) {
                localVarQueryParameter['paymentType'] = paymentType;
            }

            if (orderStatus) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (paymentStatus) {
                localVarQueryParameter['paymentStatus'] = paymentStatus;
            }

            if (orderType) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (paymentTypePos) {
                localVarQueryParameter['paymentTypePos'] = paymentTypePos;
            }

            if (invoiceCompanyId !== undefined) {
                localVarQueryParameter['invoiceCompanyId'] = invoiceCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HistoryApi - functional programming interface
 * @export
 */
export const HistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export online order history as CSV
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportOrderHistoryOnline(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderExportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportOrderHistoryOnline(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.exportOrderHistoryOnline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export POS order history as CSV
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportOrderHistoryPOS(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderExportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportOrderHistoryPOS(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.exportOrderHistoryPOS']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get order history
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderHistoryOnline(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderHistoryOnline(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.getOrderHistoryOnline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get order history for POS
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderHistoryPOS(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderHistoryPosResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderHistoryPOS(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.getOrderHistoryPOS']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HistoryApi - factory interface
 * @export
 */
export const HistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HistoryApiFp(configuration)
    return {
        /**
         * 
         * @summary Export online order history as CSV
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrderHistoryOnline(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderExportResponseDto> {
            return localVarFp.exportOrderHistoryOnline(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export POS order history as CSV
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrderHistoryPOS(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderExportResponseDto> {
            return localVarFp.exportOrderHistoryPOS(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get order history
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHistoryOnline(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderHistoryResponseDto> {
            return localVarFp.getOrderHistoryOnline(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get order history for POS
         * @param {Array<number>} businessIds Business ID selected
         * @param {TimeSpan} [timeSpan] Time span
         * @param {string} [start] Start date
         * @param {string} [end] End date
         * @param {number} [page] Page number
         * @param {number} [rowPerPage] Number of rows per page
         * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
         * @param {Array<ProviderEnum>} [provider] Provider
         * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
         * @param {Array<OrderStatusEnum>} [orderStatus] Order status
         * @param {Array<PaymentStatus>} [paymentStatus] Payment status
         * @param {Array<OrderType>} [orderType] Order type
         * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
         * @param {string} [invoiceCompanyId] Filter by invoice company ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderHistoryPOS(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderHistoryPosResponseDto> {
            return localVarFp.getOrderHistoryPOS(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HistoryApi - object-oriented interface
 * @export
 * @class HistoryApi
 * @extends {BaseAPI}
 */
export class HistoryApi extends BaseAPI {
    /**
     * 
     * @summary Export online order history as CSV
     * @param {Array<number>} businessIds Business ID selected
     * @param {TimeSpan} [timeSpan] Time span
     * @param {string} [start] Start date
     * @param {string} [end] End date
     * @param {number} [page] Page number
     * @param {number} [rowPerPage] Number of rows per page
     * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
     * @param {Array<ProviderEnum>} [provider] Provider
     * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
     * @param {Array<OrderStatusEnum>} [orderStatus] Order status
     * @param {Array<PaymentStatus>} [paymentStatus] Payment status
     * @param {Array<OrderType>} [orderType] Order type
     * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
     * @param {string} [invoiceCompanyId] Filter by invoice company ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public exportOrderHistoryOnline(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).exportOrderHistoryOnline(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export POS order history as CSV
     * @param {Array<number>} businessIds Business ID selected
     * @param {TimeSpan} [timeSpan] Time span
     * @param {string} [start] Start date
     * @param {string} [end] End date
     * @param {number} [page] Page number
     * @param {number} [rowPerPage] Number of rows per page
     * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
     * @param {Array<ProviderEnum>} [provider] Provider
     * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
     * @param {Array<OrderStatusEnum>} [orderStatus] Order status
     * @param {Array<PaymentStatus>} [paymentStatus] Payment status
     * @param {Array<OrderType>} [orderType] Order type
     * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
     * @param {string} [invoiceCompanyId] Filter by invoice company ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public exportOrderHistoryPOS(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).exportOrderHistoryPOS(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get order history
     * @param {Array<number>} businessIds Business ID selected
     * @param {TimeSpan} [timeSpan] Time span
     * @param {string} [start] Start date
     * @param {string} [end] End date
     * @param {number} [page] Page number
     * @param {number} [rowPerPage] Number of rows per page
     * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
     * @param {Array<ProviderEnum>} [provider] Provider
     * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
     * @param {Array<OrderStatusEnum>} [orderStatus] Order status
     * @param {Array<PaymentStatus>} [paymentStatus] Payment status
     * @param {Array<OrderType>} [orderType] Order type
     * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
     * @param {string} [invoiceCompanyId] Filter by invoice company ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public getOrderHistoryOnline(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).getOrderHistoryOnline(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get order history for POS
     * @param {Array<number>} businessIds Business ID selected
     * @param {TimeSpan} [timeSpan] Time span
     * @param {string} [start] Start date
     * @param {string} [end] End date
     * @param {number} [page] Page number
     * @param {number} [rowPerPage] Number of rows per page
     * @param {string} [timezone] Timezone (default is \&quot;UTC\&quot;)
     * @param {Array<ProviderEnum>} [provider] Provider
     * @param {Array<PaymentTypeEnum>} [paymentType] Payment type
     * @param {Array<OrderStatusEnum>} [orderStatus] Order status
     * @param {Array<PaymentStatus>} [paymentStatus] Payment status
     * @param {Array<OrderType>} [orderType] Order type
     * @param {Array<PaymentMethod>} [paymentTypePos] Payment type POS
     * @param {string} [invoiceCompanyId] Filter by invoice company ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public getOrderHistoryPOS(businessIds: Array<number>, timeSpan?: TimeSpan, start?: string, end?: string, page?: number, rowPerPage?: number, timezone?: string, provider?: Array<ProviderEnum>, paymentType?: Array<PaymentTypeEnum>, orderStatus?: Array<OrderStatusEnum>, paymentStatus?: Array<PaymentStatus>, orderType?: Array<OrderType>, paymentTypePos?: Array<PaymentMethod>, invoiceCompanyId?: string, options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).getOrderHistoryPOS(businessIds, timeSpan, start, end, page, rowPerPage, timezone, provider, paymentType, orderStatus, paymentStatus, orderType, paymentTypePos, invoiceCompanyId, options).then((request) => request(this.axios, this.basePath));
    }
}

